import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{
        margin: 32, padding: '32px 28px',
        background: 'rgba(248,113,113,0.06)',
        border: '1px solid rgba(248,113,113,0.18)',
        borderRadius: 14, color: '#f87171',
        fontFamily: 'Inter, system-ui, sans-serif',
      }}>
        <div style={{ fontWeight: 800, fontSize: '1rem', marginBottom: 8 }}>
          ⚠️ {this.props.label || 'Erreur dans cette section'}
        </div>
        <div style={{ fontSize: '0.8rem', color: '#f8717188', fontFamily: 'monospace', marginBottom: 16 }}>
          {this.state.error?.message}
        </div>
        <button
          onClick={() => this.setState({ hasError: false, error: null })}
          style={{ background: 'rgba(248,113,113,0.12)', border: '1px solid rgba(248,113,113,0.3)', color: '#f87171', borderRadius: 8, padding: '8px 16px', fontSize: '0.82rem', cursor: 'pointer', fontWeight: 600 }}>
          ↻ Réessayer
        </button>
      </div>
    );
  }
}
